import { userPreferencesSchema, } from '@der-maschinfuehrer/contracts';
export function defaultUserPreferences(profile) {
    return userPreferencesSchema.parse({
        user_preferences_id: profile.local_profile_id,
        locale: 'cs-CZ',
        theme: 'system',
        distance_unit: 'km',
        home_country: null,
        default_role: null,
        default_work_type: null,
        route_suggestions_enabled: false,
        reduce_motion_override: 'system',
        large_touch_targets: true,
        metadata: {
            created_at: profile.created_at,
            updated_at: profile.created_at,
            revision: 0,
            tombstone: null,
        },
    });
}
//# sourceMappingURL=defaults.js.map